import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getGames(action) {
    try {
        const gamesResponse = yield call(() =>
            gamesAPI.getGames({
                skip: (action.payload.page - 1) * action.payload.top,
                top: action.payload.top,
                search: action.payload.search,
                type: action.payload.type,
                software_house: action.payload.software_house,
                deprecated: action.payload.deprecated
            })
        );

        yield put({
            type: GamesActionTypes.GET_GAMES_SUCCESS,
            payload: {
                games: gamesResponse.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting games list.");

        yield put({
            type: GamesActionTypes.GET_GAMES_FAIL,
            message: e.message
        });
    }
}

export function* getGamesWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAMES, getGames);
}

function* searchGames(action) {
    try {
        const gamesResponse = yield call(() =>
            gamesAPI.getGames({
                skip: 0,
                top: 1000000,
                search: action.payload.search,
                type: "",
                software_house: "",
                deprecated: ""
            })
        );

        yield put({
            type: GamesActionTypes.SEARCH_GAMES_SUCCESS,
            payload: {
                games: gamesResponse.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error searching games.");

        yield put({
            type: GamesActionTypes.SEARCH_GAMES_FAIL,
            message: e.message
        });
    }
}

export function* searchGamesWatcher() {
    yield takeLatest(GamesActionTypes.SEARCH_GAMES, searchGames);
}
